import React from "react"
import DatePicker from "react-datepicker";
import TimePicker from "rc-time-picker";
import 'rc-time-picker/assets/index.css';
import { es } from 'date-fns/locale';
import styled from "styled-components";


const DateTime = ({
    label = "",
    cssClassContainer = "",
    isrequired = false,
    value ="" , onChange =()=>'',
    type ="date"
}) => {


    
  
    return(
        <div className="sg-input">
             <div className="labelComponent">
                  <span> {label} </span>
            </div>
            {type === "date" &&
            <DatePicker 
                 onChange = {onChange}
                 maxDate = {new Date()}
                 locale={es}
                 className="date-nr"
                selected={value}
                dateFormat='dd/MM/yyyy'
                withPortal
                 
            /> 
        }   
           {type === "time" &&
            <TimePicker 
                style={{ width: 100 }}
                showSecond={false}
                format={"hh:mm a"}
                onChange={onChange}
                use12Hours
                inputReadOnly
                className="time-nr"
                clearIcon={false}
                dateFormat='dd/MM/yyyy'
                value={value}
                allowEmpty={false}
                popupClassName="time-popup-nr"
            />
        } 

        
                  
        <input
                className =""
                    value={value}
                    tabIndex={-1}
                    autoComplete="off"
                    style={{ opacity: 0, height: 0 }}
                    required={isrequired}
                />     
          
        </div>
    );
}

export default DateTime;